import { render, staticRenderFns } from "./OrganizationMapPointInfo.vue?vue&type=template&id=0b49536f&"
import script from "./OrganizationMapPointInfo.vue?vue&type=script&lang=js&"
export * from "./OrganizationMapPointInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports